import { doRequest } from "utils/core";

const chatbotAPI = {
  getInitChatBot: (params) => {
    const url = `api/chatbot/init`;
    return doRequest("get", url, { params });
  },
};

export default chatbotAPI;
